export default {
  "wt-select-wrapper__error-message": "_wt-select-wrapper__error-message_1ngt876_1",
  "wt-select-wrapper__note": "_wt-select-wrapper__note_1ngt876_6"
};